var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.75v.5a1 1 0 001 1h23a1 1 0 001-1v-.5a1 1 0 00-1-1H1a1 1 0 00-1 1zm0 7.5v.5a1 1 0 001 1h23a1 1 0 001-1v-.5a1 1 0 00-1-1H1a1 1 0 00-1 1zm0 7.5v.5a1 1 0 001 1h23a1 1 0 001-1v-.5a1 1 0 00-1-1H1a1 1 0 00-1 1z"
  })));
}

export default SvgCommonIconMenu;